import React from "react";
import { Box, Container, Grid, Typography, Divider, Link, IconButton } from "@mui/material";
import { Facebook, Twitter, YouTube } from "@mui/icons-material";
import SvgIcon from '@mui/material/SvgIcon';
import vimeoIcon from "../../assets/icons/vimeo-black.png";
import facebookIcon from "../../assets/icons/facebook-black.png";
import youtubeIcon from "../../assets/icons/youtube-black.png";
import twitterIcon from "../../assets/icons/twitter-black.png";
// import logo from "../../assets/images/footerlogo.png";
import logo from "../../assets/images/logo-tm.png";
import { menuItems } from "../../constants/const"; // adjust path
import { useHomeData } from "../../context/HomeDataContext";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Footer = () => {
    const { homeData, loading } = useHomeData();

    const [footerRef, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const containerVariant = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                staggerChildren: 0.1,
            },
        },
    };

    const itemVariant = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.4 },
        },
    };

    const socialLinks = {
        facebook: homeData?.facebooklink,
        twitter: homeData?.twitterlink,
        vimeo: homeData?.vimeolink,
        youtube: homeData?.youtubelink,
    };

    return (
        <Box component={motion.div}
            ref={footerRef}
            variants={containerVariant}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            sx={{
                mt: { xs: 2, sm: 2, md: 3 },
                width: "100%",
                background: "#f5f7fa",
                py: { xs: 3, sm: 4, md: 6 },
            }}
        >
            <Container
                sx={{
                    px: { xs: 3, sm: 4, md: 6 },
                    paddingLeft: { xs: "24px !important", md: "48px !important" },
                    paddingRight: { xs: "24px !important", md: "48px !important" }
                }}
            >
                {/* TOP SECTION */}
                <Grid container spacing={4} justifyContent={'space-between'}>

                    {/* LEFT SIDE */}
                    <Grid item xs={12} md={4}>
                        {/* LOGO */}
                        <Box>
                            <Box
                                component="img"
                                src={logo}
                                alt="Glapsol Logo"
                                sx={{
                                    width: { xs: "110px", sm: "130px" },
                                    objectFit: "contain"
                                }}
                            />
                        </Box>

                        {/* TEXT */}
                        <Typography
                            sx={{
                                fontSize: { xs: "14px", sm: "16px"},
                                color: "#black",
                                mb: 1,
                                maxWidth: 320
                            }}
                        >
                            Empowering businesses through cutting-edge cloud solutions and
                            strategic AI consulting. Built for the future of digital operations.
                        </Typography>

                        {/* SOCIAL ICONS */}
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <IconButton
                                component="a"
                                href={socialLinks.facebook}
                                target="_blank"
                            >
                                <Box component="img" src={facebookIcon} sx={{ width: 20 }} />
                            </IconButton>

                            <IconButton
                                component="a"
                                href={socialLinks.twitter}
                                target="_blank"
                            >
                                <Box component="img" src={twitterIcon} sx={{ width: 20 }} />
                            </IconButton>

                            <IconButton
                                component="a"
                                href={socialLinks.vimeo}
                                target="_blank"
                            >
                                <Box component="img" src={vimeoIcon} sx={{ width: 20 }} />
                            </IconButton>

                            <IconButton
                                component="a"
                                href={socialLinks.youtube}
                                target="_blank"
                            >
                                <Box component="img" src={youtubeIcon} sx={{ width: 20 }} />
                            </IconButton>
                        </Box>
                    </Grid>


                    {/* RIGHT SIDE LINKS */}
                    <Grid item xs={12} md={8}>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "repeat(1,1fr)",
                                    sm: "repeat(3,1fr)",
                                    md: "repeat(3,1fr)"
                                },
                                rowGap: 1,
                                columnGap: 12
                            }}
                        >
                            {menuItems("Germany").map((menu) => (
                                <motion.div key={menu.label} variants={itemVariant}>
                                    <Link
                                        href={menu.path}
                                        underline="none"
                                        sx={{
                                            color: "#000",
                                            fontSize: { xs: "14px", sm: "16px"},
                                            fontWeight: 400,
                                            whiteSpace: "nowrap",
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                color: "#002045",
                                                transform: "scale(1.2)"
                                            }
                                        }}
                                    >
                                        {menu.label}
                                    </Link>
                                </motion.div>
                            ))}
                        </Box>
                    </Grid>
                </Grid>


                {/* DIVIDER */}
                <Divider sx={{ my: 4 }} />


                {/* BOTTOM BAR */}
                <Grid container justifyContent={'space-between'} alignItems="center">
                    {/* LEFT COPYRIGHT */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            sx={{
                                fontSize: { xs: "14px", sm: "16px"},
                                textAlign: { xs: "center", md: "left" },
                                mb: { xs: 1, md: 0 }
                            }}
                        >
                            © {new Date().getFullYear()}  glapsol. All rights reserved.
                        </Typography>
                    </Grid>

                    {/* RIGHT LINKS */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                display: "flex",
                                gap: 3,
                                justifyContent: { xs: "center", md: "flex-end" }
                            }}
                        >
                            <a
                                href={`/termscondition`}
                                rel="noopener noreferrer"
                                style={{
                                    color: "#000",
                                    textDecoration: "none",
                                    
                                }}
                            >
                                 <Typography sx={{fontSize: { xs: "14px", sm: "16px"}}}>Terms of Service</Typography>
                            </a>

                            <a
                                href={`/privacypolicy`}
                                rel="noopener noreferrer"
                                style={{
                                    color: "#000",
                                    textDecoration: "none",
                                }}
                            >                                
                                 <Typography sx={{fontSize: { xs: "14px", sm: "16px"}}}>Privacy Policy</Typography>
                            </a>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Footer;
